import type { IUseCase } from '@/shared/contracts/use-case.contract';
import type { IHttpClient } from '@/shared/contracts/http-client.contract';
import { HttpMethod } from '@/shared/contracts/http-client.contract';

import { ENDPOINT, type UserAddress } from '../../types/user-address';

type UseCaseInput = void;

type UseCaseOutput = UserAddress[];

export class ListUserAddressesUseCase implements IUseCase<UseCaseInput, UseCaseOutput> {
  private client: IHttpClient;

  constructor(client: IHttpClient) {
    this.client = client;
  }

  async execute(): Promise<UseCaseOutput> {
    const response = await this.client.sendRequest<UseCaseOutput, UseCaseInput>({
      method: HttpMethod.GET,
      endpoint: ENDPOINT,
    });

    return response;
  }
}
